import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Content = styled.div`
  width: 700px;
  max-width: 90vw;
  height: 560px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
`;

export const TabPanel = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  animation: ${fadeIn} 0.22s ease;
`;
